import {
	consequenceSeverityTable,
	risk_frequency,
	probability_score,
} from "../stores/consequence-severity-table";

type ConsequenceSeverityTableType = {
	consequence: string;
	severity_list: Record<string, string>;
};
export const getSeverityDescription = (
	consequence: string,
	severity: string
) => {
	const consequenceKey = String(consequence || "").trim();
	const severityKey = String(severity || "")
		.toUpperCase()
		.trim();
	if (!consequenceKey || !severityKey) return "-";
	const match = consequenceSeverityTable.find(
		(item: ConsequenceSeverityTableType) => item.consequence === consequenceKey
	);
	return match?.severity_list?.[severityKey] ?? "-";
};

export const getRiskFrequencyDescription = (frequency: number) => {
	return risk_frequency[frequency as keyof typeof risk_frequency] ?? "";
};

export const getProbabilityScore = (
	severity_level: string,
	probability: string | number
) => {
	const score = `${severity_level}${probability}`;
	const riskScore = Object.entries(probability_score).find(([_, value]) =>
		value.includes(score)
	)?.[0];
	return riskScore ? `${score} - ${riskScore}` : null;
};
